import { useForm } from "react-hook-form";
import type { ActiveCompanies, Site } from "../../../../../utils/backend-types";
import { type Contract } from "../../../DeliveryOverview.types";
import { NEW_CONTRACT_DEFAULT_VALUES } from "../ContractForm/ContractForm.constants";
import { ContractFormControls } from "../ContractForm/ContractFormControls/ContractFormControls";
import { ContractFormFields } from "../ContractForm/ContractFormFields";
import { useContractSubmit } from "../ContractForm/useContractSubmit";
import type { ContractFormOptions } from "../ContractModal.types";

interface CreateFormProps {
  activeCompanies?: ActiveCompanies;
  buttonContainer?: HTMLElement;
  contract?: Contract;
  options: ContractFormOptions;
  sites?: Array<Site>;
  templateContracts?: Array<Contract>;
  withTemplate?: boolean;
  onSubmit: (contract: Contract) => Promise<void>;
  onCancel: () => void;
  missingFields: Array<string>;
  shouldFieldBeHighlighted: (
    fieldName: string,
    relevantFormValues: Record<string, unknown>
  ) => boolean;
}

function CreateForm({
  activeCompanies,
  buttonContainer,
  contract,
  options,
  templateContracts,
  withTemplate,
  sites,
  onSubmit,
  onCancel,
  missingFields,
  shouldFieldBeHighlighted
}: CreateFormProps) {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setError,
    setValue,
    watch
  } = useForm<Contract>({
    defaultValues: contract ?? NEW_CONTRACT_DEFAULT_VALUES
  });

  const onValidSubmit = useContractSubmit({ onSubmit, watch, setError });
  const submitCallback = handleSubmit(onValidSubmit);

  function handleClickCancel() {
    reset();
    onCancel();
  }

  return (
    <form className="ContractForm FormItems" onSubmit={submitCallback}>
      <ContractFormFields
        activeCompanies={activeCompanies}
        contract={contract}
        control={control}
        errors={errors}
        missingFields={missingFields}
        options={options}
        reset={reset}
        setValue={setValue}
        shouldFieldBeHighlighted={shouldFieldBeHighlighted}
        sites={sites}
        templateContracts={templateContracts}
        watch={watch}
        withTemplate={withTemplate}
      />
      <ContractFormControls
        buttonContainer={buttonContainer}
        onCancel={handleClickCancel}
        onSubmit={submitCallback}
      />
    </form>
  );
}

export { CreateForm, CreateFormProps };
